import api from "@app/api";
import type { Company, CreateCompanyPayload, UpdateCompanyEstatusPayload, UpdateCompanyPayload } from "../types/company";

const injected = api.injectEndpoints({
    endpoints: (build) => ({
        getCompanies: build.query<Company[], void>({
            query: () => ({url: '/empresas'})
        }),
        findCompany: build.query<Company, string>({
            query: (id) => ({url: `/empresas/${id}`})
        }),
        createCompany: build.mutation<Company, CreateCompanyPayload>({
            query: (data) => ({url: '/empresas', method:'POST', data}), 
        }),
        updateCompany: build.mutation<boolean, UpdateCompanyPayload>({
            query: ({id, ...data}) => ({url: `/empresas/${id}`, method:'PUT', data})
        }),
        updateCompanyStatus: build.mutation<boolean, UpdateCompanyEstatusPayload>({
            query: ({ id, action }) => ({ url: `/empresas/${id}/status?action=${action}`, method: 'PUT' })
        }),
        deleteCompany: build.mutation<boolean, number>({
            query: (id) => ({url: `/empresas/${id}`, method:'DELETE'})
        })
    })
})

injected.enhanceEndpoints({
    endpoints: {
        getCompanies: {
            providesTags: (result) =>
            result ? [...result.map(({ id }) => ({ type: 'COMPANIES' as const, id })), 'COMPANIES'] : [],
            keepUnusedDataFor: 5,
        },
        findCompany: {
            providesTags: (result) => result ? [{id: result.id, type: 'COMPANIES'}] : []
        },
        createCompany: {
            invalidatesTags: (result) =>
            result ? [{ type: 'COMPANIES', id: result.id }, 'COMPANIES'] : [],
        },
        updateCompany: {
            invalidatesTags: (_result, error, arg) =>
            !error ? [{ type: 'COMPANIES', id: arg.id }, 'COMPANIES'] : [],
        },
        deleteCompany: {
            invalidatesTags: (_result, error, arg) =>
            !error ? [{ type: 'COMPANIES', id: arg }, 'COMPANIES'] : [],
        },
        updateCompanyStatus: {
            invalidatesTags: (_result, error, arg) => 
            !error ? [{ type: 'COMPANIES', id: arg.id}, 'COMPANIES'] : [],
        }
    }
})

export const {
   useGetCompaniesQuery,
   useFindCompanyQuery,
   useCreateCompanyMutation,
   useUpdateCompanyMutation,
   useDeleteCompanyMutation,
   useUpdateCompanyStatusMutation
} = injected